import { useEffect } from 'react'

const PIXEL_ID = '1702139741167224'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

function loadPixelScript() {
  if (initialized) return
  initialized = true

  const f = window
  const b = document
  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  window.fbq('track', 'AddToCart', {
    content_name: 'Casa Sin Olor: Protocolo 7 Días',
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
    trackPageView()
  }, [])
}
